// extracted by mini-css-extract-plugin
export default {"edit-box":"NoteItem_edit-box__MvcB3"};